import React, { ReactNode } from 'react';
import styled from 'styled-components';

import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import InlineContainer from '@ad-scripts/presentation/components/common/containers/inline_container';

type XmlFileControlProps = {
  audioLabel?: string;
  audioPlayerActions: JSX.Element;
  description: string | ReactNode;
  id?: string;
  label: string;
  recordingLibrary: JSX.Element | null;
  url: string;
};

const XmlFileControl = ({
  audioLabel,
  audioPlayerActions,
  description,
  id,
  label,
  recordingLibrary,
  url,
}: XmlFileControlProps) => {
  const linkToFile = (
    <StyledLink href={url} target="_blank" rel="noopener noreferrer">
      {audioLabel}
    </StyledLink>
  );

  const control = (
    <XmlAudioControl className="xmlAudioControl">
      <XmlFile data-aid={`${id}-trackName`}>{linkToFile}</XmlFile>
      {audioPlayerActions}
      {recordingLibrary}
    </XmlAudioControl>
  );

  return <XmlFileFieldContainer data-aid={id} description={description} label={label} control={control} />;
};

export default XmlFileControl;

const StyledLink = styled.a`
  text-decoration: underline;
  color: ${p => p.theme.colors.black};
  &:hover {
    text-decoration: underline;
  }
`;

const XmlFile = styled(InlineContainer)`
  background: ${p => p.theme.colors.white};
  border-radius: 4px;
  border: 1px solid ${p => p.theme.colors.gray300};
  padding: 7px 8px;
`;

const XmlAudioControl = styled.div`
  width: 100%;
`;

const XmlFileFieldContainer = styled(FieldContainer)`
  margin-bottom: ${p => p.theme.spacing.stackXLarge};
`;
